import { Layout } from "antd";
import { Outlet } from "react-router-dom";

const Content = () => {
  return (
    <Layout.Content className="p-5 " style={{ overflowY: "auto", backgroundColor: '#fafafa' }}>
      <Outlet />
    </Layout.Content>
  );
};

export default Content;
